import Vue from 'vue';
import Vuex, {Module, ModuleOptions, Store} from 'vuex';
import {ITicketStoreState} from '@/store/modules/ticket.store';
import {IBadgeStoreState} from '@/store/modules/badge.store';
import {ILocationStoreState} from '@/store/modules/location.store';
import {IAuthStoreState} from '@/store/modules/auth.store';
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

export interface IRootState {
	ticket: ITicketStoreState;
	badge: IBadgeStoreState;
	location: ILocationStoreState;
	auth: IAuthStoreState;
}

const persist = new VuexPersistence<IRootState>({
	key: 'zcWebClient',
	// reducer: (state) => {
	// 	console.log(state);
	// 	return {
	// 		app: {
	// 			loggedInUser: state.app.loggedInUser
	// 		}
	// 	};
	// },
	modules: ['auth']
});

const dynamicRegisterPlugin = (store: Store<IRootState>) => {
	// Override dynamic module handling in vuex
	let origRegisterModule: any;
	if (store.registerModule) {
		origRegisterModule = store.registerModule.bind(store);
		// your module interfaces
		type T = IAuthStoreState;
		// @ts-ignore
		store.registerModule = (
			path: string,
			module: Module<T, IRootState>,
			options?: ModuleOptions
		) => {
			// tslint:disable-next-line:ban-types
			if ((store.state as Object).hasOwnProperty(path)) {
				origRegisterModule(path, module, { preserveState: true });
			} else {
				origRegisterModule(path, module, options);
			}
		};
	}
};


// Declare empty store first, dynamically register all modules later.
export default new Vuex.Store<IRootState>({
	plugins: [dynamicRegisterPlugin, persist.plugin]
});
